export default __webpack_public_path__ + "static/media/8.10.911a22b6.mp3";